<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'BlocArgPasDeFraisPasDeDemarchesAdministratives'
});
</script>
<template>
  <ka-container
    code="bloc-arg-pas-de-frais-pas-de-demarches-admi"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <!-- Container gauche -->
    <ka-container code="container-gauche">
      <ka-text
        code="text"
        :value="componentInstance.$cetteFormationVous.value" />
      <ka-text
        code="text-1"
        :value="componentInstance.$votreEntreprisePeut.value">
        <template #xs>
          <span v-html="t('blocArgPasDeFraisPasDeDemarchesAdmi.containerGauche.text1.xs.value', `Votre entreprise peut bénéficier de financements mutualisés. Matchers les trouve et se charge des démarches pour les obtenir. Ensuite, nous dimensionnons votre projet formation d’après les budgets identifiés.`)" />
        </template>
      </ka-text>
      <!-- Container Logo -->
      <ka-container code="container-logo">
        <ka-image
          code="image"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Image`
          }"
          value="https://ucarecdn.com/9a08111a-6409-423b-9b94-9a5e8129098e/Logo_Atlas.svg" />
        <ka-image
          code="image-1"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Image`
          }"
          value="https://ucarecdn.com/3386b5e6-c950-4377-b8c2-f0b0be4353f5/Logo_Mobilite.svg" />
        <ka-image
          code="image-2"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Image`
          }"
          value="https://ucarecdn.com/24bb21ef-46a1-48e9-a5aa-8816f60570fa/Logo_Akto.svg" />
        <ka-image
          code="image-3"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Image`
          }"
          value="https://ucarecdn.com/0af92e1f-cf2f-4f28-b4f3-0339376c6069/Logo-EP.svg" />
        <ka-image
          code="image-4"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Image`
          }"
          value="https://ucarecdn.com/970a3040-f54f-4f9c-a749-6f782d444a18/Logo_Opcommerce.svg" />
      </ka-container>
      <ka-button
        code="pourquoi-matchers-ne"
        :options="{
          ripple: true,
          hidden: null
        }">
        <span v-html="t('blocArgPasDeFraisPasDeDemarchesAdmi.containerGauche.pourquoiMatchersNe.value', `Pourquoi Matchers ne coûte rien ?`)" />
      </ka-button>
    </ka-container>
    <!-- Container droite -->
    <ka-container code="container-droite">
      <ka-text code="aucune-demarche-administrative">
        <span v-html="t('blocArgPasDeFraisPasDeDemarchesAdmi.containerDroite.aucuneDemarcheAdministrative.value', `Aucune démarche administrative`)" />
      </ka-text>
      <ka-text code="la-encore-matchers">
        <span v-html="t('blocArgPasDeFraisPasDeDemarchesAdmi.containerDroite.laEncoreMatchers.value', `Là encore, Matchers s’occupe de tout.`)" />
      </ka-text>
      <ka-icon
        code="icone"
        value="i-fa-solid:check-square" />
    </ka-container>
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { blocArgPasDeFraisPasDeDemarchesAdministrativesComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c12')
const component = blocArgPasDeFraisPasDeDemarchesAdministrativesComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  cetteFormationVous?: Nullable<string>
  votreEntreprisePeut?: Nullable<string>
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  cetteFormationVous: 'Cette formation vous coûte 0€',
  votreEntreprisePeut: 'Votre entreprise peut bénéficier de financements mutualisés. Matchers les trouve et se charge des démarches pour les obtenir. Ensuite, nous préparons un parcours de formation dimensionné d’après les budgets disponibles pour votre entreprise.',
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

const emit = defineEmits([
  'update:cetteFormationVous',
  'update:votreEntreprisePeut'
])
componentInstance.$emit = emit

syncComponentStore(componentInstance, {
  props,
  propsToWatch: {
    cetteFormationVous: true,
    votreEntreprisePeut: true
  }
})
</script>
